import { normalizeClientName } from "./normalizeClientName";

export function matchClientByName(rawName, clients = []) {
    if (!rawName || !clients.length) {
        return { client: null, matchedBy: "none", confidence: 0 };
    }

    const target = normalizeClientName(rawName);

    // ✅ Exact match
    const exact = clients.find(
        c => normalizeClientName(c.name) === target
    );
    if (exact) {
        return { client: exact, matchedBy: "exact", confidence: 1 };
    }

    // ⚠️ Partial match
    const partial = clients.find(c => {
        const name = normalizeClientName(c.name);
        return target.includes(name) || name.includes(target);
    });

    if (partial) {
        return { client: partial, matchedBy: "partial", confidence: 0.7 };
    }

    // ❌ No match
    return { client: null, matchedBy: "none", confidence: 0 };
}
